import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Settings as SettingsIcon, LogOut, ExternalLink, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: Package },
  { to: "/admin/visitors", label: "Visitors", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: SettingsIcon },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0C0A09] flex">
      <aside className="w-64 border-r ee-hairline bg-[#1C1917] flex flex-col fixed h-full">
        <div className="p-8 border-b ee-hairline">
          <h1 className="font-display text-2xl tracking-[0.14em]">EQUINE EVOLVE</h1>
          <p className="ee-overline mt-1">Admin Console</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                  isActive ? "bg-[#D4AF37] text-[#0C0A09]" : "text-[#A8A29E] hover:text-[#D4AF37]"
                }`
              }
            >
              <n.icon size={18} strokeWidth={1.5} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t ee-hairline space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-3 text-sm text-[#A8A29E] hover:text-[#D4AF37]">
            <ExternalLink size={18} strokeWidth={1.5} /> View Store
          </a>
          <button
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-[#A8A29E] hover:text-red-400"
          >
            <LogOut size={18} strokeWidth={1.5} /> Sign Out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-10">
        <Outlet />
      </main>
    </div>
  );
}
